import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { autenticado, logout } from "shared/helpers/auth-functions";
import { RootStateOrAny } from "react-redux";
import {
  putChangeLanguage,
  fetchLoggedUser,
  fetchPersonifiedUser,
} from "shared/service/StrmService";
import { getBrowserId } from "shared/init-functions/browser-id";
import { dataLayerEventAcesso } from "event-tracker/gtm-events";
import { Usuario } from "shared/interfaces/Usuario";
import i18n from "translation";

export const getLoggedUser = createAsyncThunk("users/GetUser", async () => {
  const loggedUser: any = await fetchLoggedUser(getBrowserId());
  if (loggedUser.emailPersonified) return await fetchPersonifiedUser();
  return loggedUser;
});

export const setLoggedUserLanguage = createAsyncThunk(
  "users/setLanguage",
  async (language: string) => {
    if (autenticado()) await putChangeLanguage(language);
    return language;
  }
);

export type UserState = {
  users: {
    loggedUser: Usuario;
    loading: boolean;
    firstAccess: boolean;
    firstAccessNotified: boolean;
    shouldOpenTour: boolean;
  };
};

export const usersSlice: any = createSlice({
  name: "users",
  initialState: {
    loggedUser: {},
    loading: true,
    firstAccess: false,
    firstAccessNotified: false,
    shouldOpenTour: false,
  },
  reducers: {
    notifyFirstAccess: (state) => {
      state.firstAccess = false;
      state.firstAccessNotified = true;
    },
    tourOpened: (state) => {
      state.shouldOpenTour = false;
    },
  },
  extraReducers: {
    [getLoggedUser.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.loggedUser = action.payload;
        state.loading = false;
        const firstLoginArtistsAt = new Date(
          action.payload?.firstLoginArtistsAt
        );
        const lastLoginArtistsAt = new Date(action.payload?.lastLoginArtistsAt);

        firstLoginArtistsAt.setMilliseconds(0);
        lastLoginArtistsAt.setMilliseconds(0);

        const isFirstAccess =
          firstLoginArtistsAt.getTime() === lastLoginArtistsAt.getTime();

        state.firstAccess = isFirstAccess;
        state.shouldOpenTour = isFirstAccess;
        dataLayerEventAcesso(action.payload);
        if (action.payload.currentLanguage) {
          i18n.changeLanguage(action.payload.currentLanguage);
        }
      } else {
        logout(false);
      }
    },
    [getLoggedUser.pending.type]: (state) => {
      state.loading = true;
    },
    [setLoggedUserLanguage.fulfilled.type]: (state, action) => {
      if (action.payload)
        state.loggedUser = {
          ...state.loggedUser,
          currentLanguage: action.payload,
        };
    },
  },
});

export const { notifyFirstAccess, tourOpened } = usersSlice.actions;

export const selectLoggedUser = (state: RootStateOrAny) => state.loggedUser;

export default usersSlice.reducer;
